import { Button, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import { useSuperAdminSingleSuscrip } from "../../../context/SuperAdmin/SingleSuscriptContext";
import SearchIcon from "@mui/icons-material/Search";

const HeadersUserSuscription = () => {
  const {
    toggleAddModal,
    selectedSuscribedUsers,
    toggleDeleteModal,
    plan,
    suscribedUsers,
    searchText,
    setSearchText,
  } = useSuperAdminSingleSuscrip();

  return (
    <Grid
      container
      spacing={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      {/* Texto a la izquierda */}
      <Grid item>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#336B87" }}>
          Usuarios suscritos ({suscribedUsers.length}/{plan.max_usuarios})
        </Typography>
      </Grid>

      {/* Botones agrupados a la derecha */}
      <Grid item display="flex" gap={2}>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: John Doe"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="outlined"
          onClick={() => toggleDeleteModal(true)}
          disabled={!selectedSuscribedUsers.length}
          sx={{
            borderRadius: 14,
            border: "1px solid #336B87",
            color: "#336B87",
            "&:hover": {
              backgroundColor: "#336B87",
              color: "#EEF3F6",
            },
          }}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          onClick={() => toggleAddModal(true)}
          sx={{ background: "#336B87" }}
        >
          Agregar usuarios
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersUserSuscription;
